import i18n from "i18next";
import BundleSummaryRemovableModule from "@/Pages/BuyFlow/BundleSummaryRemovableModule";
import {getCookie, setCookie} from "@/Utilities/CookieManager";

export default function BundleSummary({state, dispatch}) {

    const handleRemoveOnClick = (bundle) => {
        let newValue = [];
        const cartCookie = 'cartProducts';
        const currentCart = getCookie(cartCookie);

        if (typeof currentCart !== "undefined") {
            newValue = currentCart.filter(item => item !== bundle.productId);
        }
        dispatch({ type: "removeFromCart", payload: { removeFromCart: bundle }})

        setCookie(cartCookie, newValue, 3);
        dispatch({ type: "cartCookies", payload: { cartCookies: getCookie(cartCookie) }});
    }

    return (
        <div>
            {state.cart.filter(item => item.type === "package").map((bundle, index) => {
                return (
                    <div className="bundle-summary" key={index}>
                        <div className="bundle-summary-header">
                            <span className="bundle-summary-name">{bundle.name}</span>
                            <span className="bundle-summary-price">
                                ${state.billingFrequency === "monthly" ? bundle.price : bundle.price * 12}
                                {state.billingFrequency === "monthly" ? i18n.t("buy-flow./mo") : i18n.t("buy-flow./yr")}
                            </span>
                        </div>
                        {bundle.modules.length > 0 && <div className="bundle-summary-modules-container">
                            {bundle.modules.map((module, index) => {
                                if(module.required) {
                                    return (
                                        <div className="bundle-summary-modules" key={index}>
                                            <img className="summary-svg" alt={module.sales_name ?? module.name} src={module.icon}/>
                                            <span className="summary-modules-name">{module.sales_name ?? module.name}</span>
                                        </div>
                                    )
                                } else {
                                    return (
                                        <BundleSummaryRemovableModule
                                            key={index}
                                            index={index}
                                            module={module}
                                            bundle={bundle}
                                            bundleName={bundle.name}
                                            state={state}
                                            dispatch={dispatch}/>
                                    )
                                }
                            })}
                        </div>}
                        <i className="fa fa-times"
                           data-qa={`${bundle.name.toLowerCase().replace(' ', '-')}-bundle-summary-remove`}
                           onClick={() => handleRemoveOnClick(bundle)}/>
                    </div>
                )
            })}
        </div>
    )
}
